import { render } from "./CancelReasonsPage.vue?vue&type=template&id=7af4b55a&scoped=true"
import script from "./CancelReasonsPage.vue?vue&type=script&lang=js"
export * from "./CancelReasonsPage.vue?vue&type=script&lang=js"

import "./CancelReasonsPage.vue?vue&type=style&index=0&id=7af4b55a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\loop Company\\Apps\\cms-dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af4b55a"]])

export default __exports__